import { FunctionComponent, ReactNode } from 'react';

import styles from '../../companyInformation.module.scss';

interface DataItemComponentProps {
	text: ReactNode;
	data: string | number;
	centered?: boolean;
}

const DataItemComponent: FunctionComponent<DataItemComponentProps> = ({ text, data, centered }) => {
	return (
		<div className={`${styles.displayItem} ${centered ? styles.centered : ''}`}>
			<p className="text-light">{text}</p>

			<h2 className="mb-0 fw-medium" style={{ color: '#555' }}>
				{data}
			</h2>
		</div>
	);
};

export default DataItemComponent;
